/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listJoinedMoneyPools} from '../api'

export const useMutationListJoinedMoneyPools = createReactQueryMutationHook('listJoinedMoneyPools', listJoinedMoneyPools)
